import { ApolloError } from "@apollo/client";
import { RefObject } from "react";

import Error from "@components/error/error";
import Link from "@components/link/link";

const TopicSidebarError = ({
  error,
  focusRef,
  onClose,
}: {
  error?: ApolloError;
  focusRef: RefObject<HTMLButtonElement>;
  onClose: () => void;
}) => {
  let title = "The topic could not be loaded.";
  let description = null;
  if (
    error?.message.includes(
      "401 Client Error: Unauthorized for url: https://api.github.com/graphql"
    )
  ) {
    title = "We are unable to communicate with GitHub.";
    description = (
      <div>
        Please verify that:
        <br />
        1. You have granted access to the "{import.meta.env.VITE_APP_NAME}" app
        in{" "}
        <a
          className="underline"
          href="https://github.com/settings/applications"
        >
          GitHub
        </a>
        .<br />
        2. The{" "}
        <Link className="underline" to="/account/integrations">
          GitHub integration
        </Link>{" "}
        is connected in "{import.meta.env.VITE_APP_NAME}".
      </div>
    );
  }

  return (
    <div className="-mt-3" aria-label="Error sidebar topic">
      <div className="pt-2">
        <Error title={title} description={description} />
      </div>
    </div>
  );
};

export default TopicSidebarError;
